import { Component, OnInit } from '@angular/core';
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-player-card',
  templateUrl: './Home-page-KSA.component.html',
  styleUrls: ['./Home-page-KSA.component.scss']
})
export class HomePageKSAComponent implements OnInit {
  loadIndicator = false
  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  tournaments ;

  ngOnInit(): void {
    this.loadIndicator = true
    this.activeRoute.params.subscribe(param => {
      this.changeRoute();
    });
  }
  changeRoute() {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('tecno-pubg-mobile-cup-2-saudi-arabia', 1, 'pubg').subscribe(res => {
      this.tournaments= res.data
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })
  }
}
